import { useContext, useState } from "react";
import { BsXLg } from "react-icons/bs";
import { EnquiryGridSelectionContext } from "../../../contexts/enquiry-grid-selection.context";
import {
    EnquiryFilterGroups,
    getEnquiryFilterHeading,
    getEnquiryFilterKey,
    iEnquiryFilter,
} from "../../../interfaces/enquiryFilter";
import { LoadMailbox } from "../../../Logic/Enquiries/Load";
import { getLastTouched, saveLastTouched } from "../../../Logic/LastTouched/misc";
import FilterPopup from "../../Generic/FilterPopup";

// Funnel icon with the enquiry filters for the mailbox view. The active filters live in last touched.
function MailboxFilter() {
    const { SetEnquiryGridSelectionProperties } = useContext(EnquiryGridSelectionContext);
    const [activeFilters, setActiveFilters] = useState<iEnquiryFilter[]>(
        getLastTouched().Queue.Pagination.filters ?? [],
    );

    async function applyFilters(filters: iEnquiryFilter[]) {
        SetEnquiryGridSelectionProperties(currentState => {
            currentState.multiSelect = false;
            currentState.selectedEnquiries = [];
            return currentState;
        });
        const iLastTouched = getLastTouched();
        iLastTouched.Queue.Pagination.filters = filters;
        iLastTouched.Queue.Pagination.pageNumber = 1;
        saveLastTouched(iLastTouched);
        setActiveFilters(filters);
        await LoadMailbox(iLastTouched.Queue.ActiveList);
    }

    const activeKeys = activeFilters.map(getEnquiryFilterKey);
    const filterLabel =
        activeFilters.length > 0
            ? activeFilters.map(f => `${getEnquiryFilterHeading(f)}: ${f.label}`).join("\n")
            : "Filter enquiries";

    return (
        <div className="mailbox-filter">
            {activeFilters.length > 0 && (
                <button
                    className="mailbox-filter-clear"
                    title="Clear all filters"
                    onClick={() => applyFilters([])}
                >
                    <BsXLg style={{ width: "10px", height: "10px" }} />
                </button>
            )}
            <FilterPopup
                title={filterLabel}
                onApply={keys =>
                    applyFilters(
                        EnquiryFilterGroups.flatMap(g => g.options).filter(o => keys.includes(getEnquiryFilterKey(o))),
                    )
                }
                groups={EnquiryFilterGroups.map(group => ({
                    key: group.heading,
                    label: group.heading,
                    items: group.options.map(option => ({
                        key: getEnquiryFilterKey(option),
                        label: option.label,
                        selected: activeKeys.includes(getEnquiryFilterKey(option)),
                    })),
                }))}
            />
        </div>
    );
}

export default MailboxFilter;
